import {createSvgIcon} from '../create-svg-icon';

export const TextRotationDownIcon = createSvgIcon(
  <path d="m6 20 3-3H7V4H5v13H3l3 3zm6.2-11.5v5l-2.2.9v2.1l11-4.75v-1.5L10 5.5v2.1l2.2.9zm6.82 2.5L14 12.87V9.13L19.02 11z" />
, 'TextRotationDownOutlined');
